import AddonsSelector from './AddonsSelector';
import { ADDON_LIST, getAddonPrices } from './addons';
import BookingSuccessModal from './BookingSuccessModal';
import React, { useState, useEffect, useCallback } from 'react';
import AvailabilityCalendar from './AvailabilityCalendar';

const API = 'https://api.botanix.in/api';

const C = {
 bg:'#0A1628', surface:'#0F2040', surface2:'#162A40',
 border:'rgba(30,58,95,.8)', border2:'rgba(30,58,95,1)',
 text:'#F0F2FF', text2:'#A0A8C0', text3:'#606880',
 accent:'#22C55E', blue:'#FFFFFF',
 red:'#EF4444', redBg:'rgba(239,68,68,.10)', redBorder:'rgba(239,68,68,.25)',
 amber:'#F59E0B', amberBg:'rgba(245,158,11,.10)', amberBorder:'rgba(245,158,11,.25)',
};

const inr = n => 'Ã¢—šÂ¹' + Number(n||0).toLocaleString('en-IN',{maximumFractionDigits:0});

const OCCUPANCY_TYPES = [
 { id:'single', label:'Single Occupancy', multiplier:1.0, desc:'1 adult' },
 { id:'double', label:'Double Sharing', multiplier:1.0, desc:'2 adults' },
 { id:'triple', label:'Triple Sharing', multiplier:1.2, desc:'3 adults (extra bed)' },
];

const MEAL_PLANS = [
 { id:'EP', label:'EP', desc:'Room Only', rate:0 },
 { id:'CP', label:'CP', desc:'+ Breakfast', rate:500 },
 { id:'MAP', label:'MAP', desc:'+ Breakfast & Dinner', rate:900 },
 { id:'AP', label:'AP', desc:'+ All Meals', rate:1400 },
];

const ACTIVITIES = ['Nature Walk','Camel Ride','Bullock Cart','Paintball','Archery','Zipline','Cycling','Bird Watching','Bonfire','Star Gazing'];
const SOURCES = ['Direct','Phone','Email','WhatsApp','Referral','OTA','Website','Corporate'];
const NATIONALITIES = ['Indian','Foreigner - SAARC','Foreigner - International'];

const inp = {
 width:'100%', padding:'10px 12px',
 background:'rgba(255,255,255,.05)', border:`1px solid rgba(30,58,95,1)`,
 borderRadius:8, color:'#F0F2FF', fontSize:13,
 boxSizing:'border-box', outline:'none', fontFamily:'Inter,sans-serif'
};
const sel = { ...inp, cursor:'pointer' };
const Label = ({children}) => (
 <label style={{ display:'block', fontSize:11, color:'#A0A8C0', marginBottom:4, fontWeight:700, textTransform:'uppercase', letterSpacing:'.05em' }}>{children}</label>
);

export default function RoomStayBooking({ onClose, onSave, bookingToEdit }) {
 const currentUser = (() => { try { return JSON.parse(localStorage.getItem('botanix_user')); } catch { return null; } })();
 const roleKey = currentUser?.roleKey || currentUser?.role || '';
 const isSales = roleKey === 'SALES';
 const isSuperAdmin = roleKey === 'SUPER_ADMIN';

 const [step, setStep] = useState(1);
 const [savedBooking, setSavedBooking] = useState(null);
 const [saving, setSaving] = useState(false);
 const [error, setError] = useState('');
 const [roomTypes, setRoomTypes] = useState([]);
 const [pricingRates, setPricingRates] = useState([]);

 // Step 1 Ã¢â¬— Guest Details
 const [guestName, setGuestName] = useState(bookingToEdit?.guest_name||'');
 const [guestPhone, setGuestPhone] = useState(bookingToEdit?.guest_phone||'');
 const [guestEmail, setGuestEmail] = useState(bookingToEdit?.guest_email||'');
 const [nationality, setNationality] = useState('Indian');
 const [company, setCompany] = useState('');
 const [gstNum, setGstNum] = useState('');
 const [source, setSource] = useState('Direct');
 const [salesperson, setSalesperson] = useState(bookingToEdit?.salesperson||currentUser?.name||'');
 const [status, setStatus] = useState(bookingToEdit?.booking_status||'Confirmed');
 const [notes, setNotes] = useState('');

 // Step 2 Ã¢â¬— Dates & Rooms
 const [startDate, setStartDate] = useState(bookingToEdit?.start_date?.slice(0,10)||'');
 const [endDate, setEndDate] = useState(bookingToEdit?.end_date?.slice(0,10)||'');
 const [roomAllocations, setRoomAllocations] = useState([
 { room_type_id:'', occupancy:'double', rooms:1, rate:0, meal_plan:'CP', meal_rate:500 }
 ]);

 // Step 3 Ã¢â¬— Guests breakdown
 const [adults, setAdults] = useState(2);
 const [children6to10, setChildren6to10] = useState(0);
 const [children10to18, setChildren10to18] = useState(0);
 const [childRate6to10, setChildRate6to10] = useState(2500);
 const [childRate10to18, setChildRate10to18] = useState(3500);
 const [foreignerSurcharge, setForeignerSurcharge] = useState(0);

 // Step 4 Ã¢â¬— Activities & Addons
 const [selectedActivities, setSelectedActivities] = useState([]);
 const [activityRate, setActivityRate] = useState(500);
 const [addons, setAddons] = useState({});
 const [addonPrices, setAddonPrices] = useState(getAddonPrices());
 const [discountPct, setDiscountPct] = useState(0);
 const [advancePaid, setAdvancePaid] = useState(0);

 // Load room types and pricing
 useEffect(() => {
 Promise.all([
 fetch(`${API}/rooms/types`).then(r=>r.json()),
 fetch(`${API}/pricing/current-rates`).then(r=>r.json()),
 ]).then(([rt, pr]) => {
 if (Array.isArray(rt)) {
 setRoomTypes(rt);
 // Set default room type
 if (rt.length > 0 && !roomAllocations[0].room_type_id) {
 const rate = parseFloat(rt[0].base_tariff||0);
 setRoomAllocations([{ room_type_id:rt[0].id, occupancy:'double', rooms:1, rate, meal_plan:'CP', meal_rate:500 }]);
 }
 }
 if (Array.isArray(pr)) setPricingRates(pr);
 }).catch(()=>{});
 }, []);

 // Get live rate for room type
 const getLiveRate = (roomTypeId) => {
 const pr = pricingRates.find(r=>r.room_type_id===parseInt(roomTypeId));
 if (pr) return parseFloat(pr.today_rate||pr.base_rate||0);
 const rt = roomTypes.find(r=>r.id===parseInt(roomTypeId));
 return parseFloat(rt?.base_tariff||0);
 };

 const nights = startDate && endDate
 ? Math.max(1, Math.ceil((new Date(endDate)-new Date(startDate))/86400000))
 : 1;

 const updateRoom = (i,k,v) => setRoomAllocations(p=>p.map((r,idx)=>{
 if (idx!==i) return r;
 const updated = {...r,[k]:v};
 if (k==='room_type_id') updated.rate = getLiveRate(v);
 if (k==='meal_plan') updated.meal_rate = MEAL_PLANS.find(m=>m.id===v)?.rate||0;
 if (k==='occupancy') updated.multiplier = OCCUPANCY_TYPES.find(o=>o.id===v)?.multiplier||1;
 return updated;
 }));

 const addRoom = () => {
 const rt = roomTypes[0];
 setRoomAllocations(p=>[...p,{room_type_id:rt?.id||'',occupancy:'double',rooms:1,rate:getLiveRate(rt?.id),meal_plan:'CP',meal_rate:500}]);
 };

 const removeRoom = (i) => setRoomAllocations(p=>p.filter((_,idx)=>idx!==i));

 // Calculations
 const roomAmount = roomAllocations.reduce((s,r)=>{
 const occ = OCCUPANCY_TYPES.find(o=>o.id===r.occupancy);
 const mult = occ?.multiplier||1;
 return s + (r.rate*mult*r.rooms*nights) + ((r.meal_rate||0)*((adults||1)+(children10to18||0))*nights*r.rooms);
 },0);

 const childAmount = (children6to10*childRate6to10) + (children10to18*childRate10to18);
 const actAmount=selectedActivities.length*activityRate*(adults+(children10to18||0));
 const addonAmount=Object.entries(addons).reduce((s,[id,a])=>{if(!a?.enabled)return s;const price=parseFloat(a.price||0);const qty=parseInt(a.qty||1);return s+(price*qty);},0);
 const foreignerAmt = nationality!=='Indian' ? (adults*(foreignerSurcharge||0)) : 0;
 const subtotal=roomAmount+childAmount+actAmount+foreignerAmt+(addonAmount||0);
 const discount = subtotal*(discountPct/100);
 const taxable = subtotal - discount;
 const gst = taxable*0.18;
 const total = taxable + gst;
 const totalPax = adults + (children6to10||0) + (children10to18||0);

 const handleSave = async () => {
 if (!guestName) { setError('Enter guest name'); return; }
 if (!startDate) { setError('Select check-in date'); return; }
 if (!endDate) { setError('Select check-out date'); return; }
 setSaving(true); setError('');
 try {
 const roomData = {
 type:'room_stay', nationality, occupancy:roomAllocations,
 adults, children6to10, children10to18,
 childRate6to10, childRate10to18,
 activities:selectedActivities, activityRate,
 discountPct, nights,
 };
 const payload = {
 booking_type: 'Ã°Å¸ÂÂ¨ Room Stay',
 guest_name: guestName,
 guest_phone: guestPhone,
 guest_email: guestEmail,
 pax_count: totalPax,
 start_date: startDate,
 end_date: endDate,
 source, salesperson,
 booking_status: status,
 total_amount: Math.round(total),
 advance_paid: parseFloat(advancePaid||0),
 balance_amount: Math.round(total) - parseFloat(advancePaid||0),
 notes: `<<<ROOM_DATA:${JSON.stringify(roomData)}>>>`,
 };
 const url = bookingToEdit ? `${API}/bookings/${bookingToEdit.id}` : `${API}/bookings`;
 const method = bookingToEdit ? 'PUT' : 'POST';
 const r = await fetch(url,{method,headers:{'Content-Type':'application/json'},body:JSON.stringify(payload)});
 if (!r.ok) throw new Error('Save failed');
 const saved=await (await fetch(API+'/bookings')).json();
 const latest=Array.isArray(saved)?saved.sort((a,b)=>b.id-a.id)[0]:null;
 setSavedBooking(latest||{...payload,booking_code:'BTX-NEW'});
 onSave?.();
 } catch(e) { setError(e.message); }
 finally { setSaving(false); }
 };

 const STEPS = ['Guest Details','Dates & Rooms','Guest Breakdown','Activities & Pricing'];

 if (savedBooking) return <BookingSuccessModal booking={savedBooking} onClose={()=>{setSavedBooking(null);onClose?.();}} onPrint={()=>{setSavedBooking(null);onClose?.();}} />;

 return (
 <div style={{ position:'fixed', inset:0, background:'rgba(0,0,0,.85)', zIndex:2000, display:'flex', alignItems:'center', justifyContent:'center', padding:16 }}>
 <div style={{ background:C.bg, border:`1px solid ${C.border}`, borderRadius:16, width:'100%', maxWidth:740, maxHeight:'92vh', display:'flex', flexDirection:'column', overflow:'hidden' }}>

 {/* Header */}
 <div style={{ padding:'16px 20px', borderBottom:`1px solid ${C.border}`, display:'flex', justifyContent:'space-between', alignItems:'center', flexShrink:0, background:C.surface }}>
 <div>
 <div style={{ fontWeight:800, fontSize:16, color:C.text }}>Ã°Å¸ÂÂ¨ {bookingToEdit?'Edit':'New'} Room Stay Booking</div>
 <div style={{ fontSize:12, color:C.text2, marginTop:2 }}>Step {step} of 4 Ã¢â¬— {STEPS[step-1]}</div>
 </div>
 <button onClick={onClose} style={{ background:'none', border:'none', color:C.text2, fontSize:20, cursor:'pointer' }}>Ã¢Å‘—¢</button>
 </div>

 {/* Step indicators */}
 <div style={{ display:'flex', padding:'12px 20px', gap:6, borderBottom:`1px solid ${C.border}`, flexShrink:0, background:C.surface }}>
 {STEPS.map((s,i)=>(
 <div key={i} style={{ flex:1, textAlign:'center', cursor:'pointer' }} onClick={()=>i<step-1&&setStep(i+1)}>
 <div style={{ width:26, height:26, borderRadius:'50%', background:step>i+1?C.accent:step===i+1?C.accent:'rgba(255,255,255,.1)', color:'#fff', display:'flex', alignItems:'center', justifyContent:'center', fontSize:11, fontWeight:700, margin:'0 auto 3px' }}>{step>i+1?'Ã¢Å‘‘':i+1}</div>
 <div style={{ fontSize:10, color:step===i+1?C.accent:C.text3, lineHeight:1.2 }}>{s}</div>
 </div>
 ))}
 </div>

 {/* Content */}
 <div style={{ flex:1, overflowY:'auto', padding:20 }}>
 {error && <div style={{ padding:'10px 14px', background:C.redBg, border:`1px solid ${C.redBorder}`, borderRadius:8, color:C.red, fontSize:13, marginBottom:16 }}>Ã¢Å¡Â  {error}</div>}

 {/* Ã¢—â¬Ã¢—â¬ STEP 1: GUEST DETAILS Ã¢—â¬Ã¢—â¬ */}
 {step===1 && (
 <div style={{ display:'grid', gap:14 }}>
 <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:12 }}>
 <div>
 <Label>Guest Name *</Label>
 <input style={inp} value={guestName} onChange={e=>setGuestName(e.target.value)} placeholder="Full name" />
 </div>
 <div>
 <Label>Nationality</Label>
 <select style={sel} value={nationality} onChange={e=>setNationality(e.target.value)}>
 {NATIONALITIES.map(n=><option key={n} style={{background:'#0F2040',color:'#F0F2FF'}}>{n}</option>)}
 </select>
 </div>
 </div>
 <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:12 }}>
 <div>
 <Label>Phone</Label>
 <input style={inp} value={guestPhone} onChange={e=>setGuestPhone(e.target.value)} placeholder="+91 98100 00000" />
 </div>
 <div>
 <Label>Email</Label>
 <input style={inp} type="email" value={guestEmail} onChange={e=>setGuestEmail(e.target.value)} placeholder="guest@email.com" />
 </div>
 </div>
 <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:12 }}>
 <div>
 <Label>Company (B2B)</Label>
 <input style={inp} value={company} onChange={e=>setCompany(e.target.value)} placeholder="Company name" />
 </div>
 <div>
 <Label>GST Number</Label>
 <input style={inp} value={gstNum} onChange={e=>setGstNum(e.target.value)} placeholder="For B2B invoicing" />
 </div>
 </div>
 <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr 1fr', gap:12 }}>
 <div>
 <Label>Source</Label>
 <select style={sel} value={source} onChange={e=>setSource(e.target.value)}>
 {SOURCES.map(s=><option key={s} style={{background:'#0F2040',color:'#F0F2FF'}}>{s}</option>)}
 </select>
 </div>
 <div>
 <Label>Salesperson</Label>
 <input style={{...inp, opacity:isSales?.7:1}} value={salesperson} onChange={e=>!isSales&&setSalesperson(e.target.value)} readOnly={isSales} />
 </div>
 <div>
 <Label>Status</Label>
 <select style={sel} value={status} onChange={e=>setStatus(e.target.value)}>
 {['Confirmed','Tentative','Cancelled'].map(s=><option key={s} style={{background:'#0F2040',color:'#F0F2FF'}}>{s}</option>)}
 </select>
 </div>
 </div>
 {nationality !== 'Indian' && (
 <div style={{ padding:14, background:C.amberBg, border:`1px solid ${C.amberBorder}`, borderRadius:10 }}>
 <div style={{ fontWeight:700, fontSize:13, color:C.amber, marginBottom:8 }}>Ã°Å¸Å’Â Foreign National Ã¢â¬— Additional Charges</div>
 <div>
 <Label>Foreigner Surcharge per Adult (Ã¢—šÂ¹)</Label>
 <input style={inp} type="number" value={foreignerSurcharge} onChange={e=>setForeignerSurcharge(parseFloat(e.target.value)||0)} placeholder="e.g. 1500" />
 </div>
 </div>
 )}
 </div>
 )}

 {/* Ã¢—â¬Ã¢—â¬ STEP 2: DATES & ROOMS Ã¢—â¬Ã¢—â¬ */}
 {step===2 && (
 <div>
 {/* Calendar */}
 <div style={{ marginBottom:16 }}>
 <Label>Check-in & Check-out Dates *</Label>
 <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:12, marginBottom:12 }}>
 <div>
 <Label>Check-in</Label>
 <input style={inp} type="date" value={startDate} onChange={e=>setStartDate(e.target.value)} />
 </div>
 <div>
 <Label>Check-out</Label>
 <input style={inp} type="date" value={endDate} onChange={e=>setEndDate(e.target.value)} />
 </div>
 </div>
 {startDate && endDate && (
 <div style={{ padding:'8px 12px', background:`${C.accent}15`, border:`1px solid ${C.accent}33`, borderRadius:8, fontSize:13, color:C.accent }}>
 Ã¢Å‘‘ {nights} night{nights>1?'s':''} Ã· Check-out: {new Date(endDate).toLocaleDateString('en-IN',{weekday:'short',day:'numeric',month:'short'})}
 </div>
 )}
 </div>

 {/* Room Allocations */}
 <div style={{ marginBottom:12 }}>
 <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:10 }}>
 <div style={{ fontWeight:700, fontSize:14, color:C.text }}>Ã°Å¸—ºÂ Room Allocation</div>
 <button onClick={addRoom} style={{ padding:'5px 12px', background:`${C.accent}20`, border:`1px solid ${C.accent}44`, borderRadius:6, color:C.accent, cursor:'pointer', fontSize:12, fontWeight:700 }}>+ Add Room</button>
 </div>

 {roomAllocations.map((r,i)=>{
 const rt = roomTypes.find(t=>t.id===parseInt(r.room_type_id));
 const liveRate = getLiveRate(r.room_type_id);
 const occ = OCCUPANCY_TYPES.find(o=>o.id===r.occupancy);
 const roomTotal = (liveRate*(occ?.multiplier||1)*r.rooms*nights);
 return (
 <div key={i} style={{ background:C.surface, border:`1px solid ${C.border}`, borderRadius:12, padding:16, marginBottom:10 }}>
 <div style={{ display:'grid', gridTemplateColumns:'2fr 1fr 1fr auto', gap:10, marginBottom:10 }}>
 <div>
 <Label>Room Type</Label>
 <select style={sel} value={r.room_type_id} onChange={e=>updateRoom(i,'room_type_id',parseInt(e.target.value))}>
 <option value="" style={{background:'#0F2040',color:'#F0F2FF'}}>Select room type</option>
 {roomTypes.map(rt=><option key={rt.id} value={rt.id} style={{background:'#0F2040',color:'#F0F2FF'}}>{rt.name} Ã¢â¬— {inr(parseFloat(rt.base_tariff))}/night</option>)}
 </select>
 </div>
 <div>
 <Label>No. of Rooms</Label>
 <input style={inp} type="number" value={r.rooms} onChange={e=>updateRoom(i,'rooms',parseInt(e.target.value)||1)} min={1} />
 </div>
 <div>
 <Label>Rate/Room/Night</Label>
 <input style={inp} type="number" value={r.rate||liveRate} onChange={e=>updateRoom(i,'rate',parseFloat(e.target.value)||0)} />
 </div>
 <button onClick={()=>removeRoom(i)} style={{ alignSelf:'flex-end', padding:'10px', background:C.redBg, border:`1px solid ${C.redBorder}`, borderRadius:6, color:C.red, cursor:'pointer', fontSize:12 }}>Ã¢Å‘—¢</button>
 </div>

 {/* Occupancy Type */}
 <div style={{ marginBottom:10 }}>
 <Label>Occupancy Type</Label>
 <div style={{ display:'flex', gap:8 }}>
 {OCCUPANCY_TYPES.map(o=>(
 <div key={o.id} onClick={()=>updateRoom(i,'occupancy',o.id)}
 style={{ flex:1, padding:'8px 10px', background:r.occupancy===o.id?`${C.accent}20`:C.surface2, border:`2px solid ${r.occupancy===o.id?C.accent:C.border}`, borderRadius:8, cursor:'pointer', textAlign:'center' }}>
 <div style={{ fontSize:12, fontWeight:700, color:r.occupancy===o.id?C.accent:C.text }}>{o.label}</div>
 <div style={{ fontSize:10, color:C.text3 }}>{o.desc}</div>
 {o.multiplier!==1 && <div style={{ fontSize:10, color:C.amber }}>+{((o.multiplier-1)*100).toFixed(0)}%</div>}
 </div>
 ))}
 </div>
 </div>

 {/* Meal Plan */}
 <div>
 <Label>Meal Plan</Label>
 <div style={{ display:'flex', gap:6 }}>
 {MEAL_PLANS.map(m=>(
 <div key={m.id} onClick={()=>updateRoom(i,'meal_plan',m.id)}
 style={{ flex:1, padding:'8px', background:r.meal_plan===m.id?`${C.amber}20`:C.surface2, border:`2px solid ${r.meal_plan===m.id?C.amber:C.border}`, borderRadius:8, cursor:'pointer', textAlign:'center' }}>
 <div style={{ fontSize:13, fontWeight:800, color:r.meal_plan===m.id?C.amber:C.text }}>{m.id}</div>
 <div style={{ fontSize:10, color:C.text3 }}>{m.desc}</div>
 {m.rate>0 && <div style={{ fontSize:10, color:C.amber }}>+{inr(m.rate)}/pax</div>}
 </div>
 ))}
 </div>
 </div>

 <div style={{ marginTop:10, textAlign:'right', fontSize:13, color:C.accent, fontWeight:700 }}>
 Room subtotal: {inr(roomTotal)} ({r.rooms} room Ãƒ—— {nights} nights)
 </div>
 </div>
 );
 })}
 </div>
 </div>
 )}

 {/* Ã¢—â¬Ã¢—â¬ STEP 3: GUEST BREAKDOWN Ã¢—â¬Ã¢—â¬ */}
 {step===3 && (
 <div style={{ display:'grid', gap:16 }}>
 <div style={{ background:C.surface, border:`1px solid ${C.border}`, borderRadius:12, padding:18 }}>
 <div style={{ fontWeight:700, fontSize:14, color:C.text, marginBottom:14 }}>Ã°Å¸—Â¥ Guest Breakdown</div>

 {/* Adults */}
 <div style={{ marginBottom:14 }}>
 <Label>Adults (18+ years)</Label>
 <div style={{ display:'flex', alignItems:'center', gap:12 }}>
 <input style={{...inp, width:100}} type="number" value={adults} onChange={e=>setAdults(parseInt(e.target.value)||0)} min={1} />
 <div style={{ fontSize:12, color:C.text2 }}>Rate included in room package</div>
 </div>
 </div>

 {/* Children 10-18 */}
 <div style={{ marginBottom:14, padding:12, background:`${C.amber}10`, border:`1px solid ${C.amber}33`, borderRadius:8 }}>
 <Label>Children 10-18 years (charged as adults)</Label>
 <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:12 }}>
 <div>
 <Label>Count</Label>
 <input style={inp} type="number" value={children10to18} onChange={e=>setChildren10to18(parseInt(e.target.value)||0)} min={0} />
 </div>
 <div>
 <Label>Rate per child (Ã¢—šÂ¹)</Label>
 <input style={inp} type="number" value={childRate10to18} onChange={e=>setChildRate10to18(parseFloat(e.target.value)||0)} />
 </div>
 </div>
 {children10to18>0 && <div style={{ fontSize:12, color:C.amber, marginTop:6 }}>Amount: {inr(children10to18*childRate10to18)}</div>}
 </div>

 {/* Children 6-10 */}
 <div style={{ marginBottom:14, padding:12, background:`rgba(167,139,250,.1)`, border:`1px solid rgba(167,139,250,.3)`, borderRadius:8 }}>
 <Label>Children 6-10 years (partial charge)</Label>
 <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:12 }}>
 <div>
 <Label>Count</Label>
 <input style={inp} type="number" value={children6to10} onChange={e=>setChildren6to10(parseInt(e.target.value)||0)} min={0} />
 </div>
 <div>
 <Label>Rate per child (Ã¢—šÂ¹)</Label>
 <input style={inp} type="number" value={childRate6to10} onChange={e=>setChildRate6to10(parseFloat(e.target.value)||0)} />
 </div>
 </div>
 {children6to10>0 && <div style={{ fontSize:12, color:'#A78BFA', marginTop:6 }}>Amount: {inr(children6to10*childRate6to10)}</div>}
 </div>

 {/* Under 6 */}
 <div style={{ padding:12, background:`${C.accent}10`, border:`1px solid ${C.accent}33`, borderRadius:8 }}>
 <div style={{ fontSize:13, color:C.accent, fontWeight:600 }}>Ã¢Å‘‘ Children below 6 years Ã¢â¬— Complimentary</div>
 <div style={{ fontSize:11, color:C.text3, marginTop:2 }}>No charge for children under 6 years of age</div>
 </div>
 </div>

 {/* Summary */}
 <div style={{ background:C.surface, border:`1px solid ${C.border}`, borderRadius:12, padding:16 }}>
 <div style={{ fontWeight:700, fontSize:14, color:C.text, marginBottom:10 }}>Guest Summary</div>
 {[
 ['Adults (18+)', adults, 'Ã¢â¬—', 'Included in room rate'],
 ['Children (10-18)', children10to18, inr(childRate10to18), inr(children10to18*childRate10to18)],
 ['Children (6-10)', children6to10, inr(childRate6to10), inr(children6to10*childRate6to10)],
 ['Children (under 6)', 0, 'Ã¢â¬—', 'Complimentary'],
 ].map(([label,count,rate,amt])=>(
 <div key={label} style={{ display:'flex', justifyContent:'space-between', padding:'6px 0', borderBottom:`1px solid ${C.border}`, fontSize:13 }}>
 <span style={{ color:C.text2 }}>{label}</span>
 <span style={{ color:C.text3 }}>Count: {count}</span>
 <span style={{ color:C.text3 }}>Rate: {rate}</span>
 <span style={{ color:C.accent, fontWeight:600 }}>{amt}</span>
 </div>
 ))}
 <div style={{ display:'flex', justifyContent:'space-between', padding:'8px 0', fontSize:14, fontWeight:700 }}>
 <span style={{ color:C.text }}>Total Pax</span>
 <span style={{ color:C.accent }}>{totalPax} persons</span>
 </div>
 </div>
 </div>
 )}

 {/* Ã¢—â¬Ã¢—â¬ STEP 4: ACTIVITIES & PRICING Ã¢—â¬Ã¢—â¬ */}
 {step===4 && (
 <div>
 {/* Activities */}
 <div style={{ background:C.surface, border:`1px solid ${C.border}`, borderRadius:12, padding:18, marginBottom:16 }}>
 <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:12 }}>
 <div style={{ fontWeight:700, fontSize:14, color:C.text }}>Ã¢—ºÂ° Activities</div>
 <div>
 <Label>Rate per person (Ã¢—šÂ¹)</Label>
 <input style={{...inp, width:100}} type="number" value={activityRate} onChange={e=>setActivityRate(parseFloat(e.target.value)||0)} />
 </div>
 </div>
 <div style={{ display:'flex', flexWrap:'wrap', gap:6 }}>
 {ACTIVITIES.map(a=>(
 <span key={a} onClick={()=>setSelectedActivities(p=>p.includes(a)?p.filter(x=>x!==a):[...p,a])}
 style={{ padding:'6px 12px', borderRadius:20, fontSize:12, cursor:'pointer', fontWeight:500,
 background:selectedActivities.includes(a)?C.amber:'rgba(255,255,255,.06)',
 color:selectedActivities.includes(a)?'#fff':C.text2,
 border:`1px solid ${selectedActivities.includes(a)?C.amber:C.border}` }}>
 {a}
 </span>
 ))}
 </div>
 </div>

 <div style={{marginBottom:16}}><AddonsSelector addons={addons} onChange={setAddons} pax={totalPax} isAdmin={true} /></div>
 {/* Final Pricing */}
 <div style={{ background:C.surface, border:`1px solid ${C.accent}44`, borderRadius:12, padding:18, marginBottom:16 }}>
 <div style={{ fontWeight:700, fontSize:14, color:C.text, marginBottom:14 }}>Ã°Å¸’Â° Pricing Summary</div>
 {[
 ['Room Charges', inr(roomAmount), true],
 ['Child Charges (10-18)', inr(children10to18*childRate10to18), children10to18>0],
 ['Child Charges (6-10)', inr(children6to10*childRate6to10), children6to10>0],
 ['Foreigner Surcharge', inr(foreignerAmt), nationality!=='Indian'&&foreignerAmt>0],
 ['Activities', inr(actAmount), actAmount>0],
 ].filter(([,, show])=>show).map(([k,v])=>(
 <div key={k} style={{ display:'flex', justifyContent:'space-between', padding:'5px 0', fontSize:13 }}>
 <span style={{ color:C.text2 }}>{k}</span><span style={{ color:C.text }}>{v}</span>
 </div>
 ))}
 <div style={{ margin:'10px 0', borderTop:`1px solid ${C.border}`, paddingTop:10 }}>
 <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:10 }}>
 <span style={{ fontSize:13, color:C.text2 }}>Discount %</span>
 <input type="number" value={discountPct} onChange={e=>setDiscountPct(Math.min(isSuperAdmin?100:20,Math.max(0,parseFloat(e.target.value)||0)))}
 style={{...inp, width:80, padding:'4px 8px', textAlign:'right'}} min={0} max={isSuperAdmin?100:20} />
 </div>
 {[
 ['Discount', '-'+inr(discount)],
 ['Taxable Amount', inr(taxable)],
 ['GST @ 18%', inr(gst)],
 ].map(([k,v])=>(
 <div key={k} style={{ display:'flex', justifyContent:'space-between', padding:'4px 0', fontSize:13 }}>
 <span style={{ color:C.text2 }}>{k}</span><span style={{ color:C.text }}>{v}</span>
 </div>
 ))}
 </div>
 <div style={{ display:'flex', justifyContent:'space-between', padding:'10px 0 0', borderTop:`1px solid ${C.border}`, fontSize:18, fontWeight:900 }}>
 <span style={{ color:C.text }}>Total Amount</span>
 <span style={{ color:C.accent }}>{inr(total)}</span>
 </div>
 </div>

 {/* Advance */}
 <div style={{ background:C.surface, border:`1px solid ${C.border}`, borderRadius:12, padding:16 }}>
 <Label>Advance Paid (Ã¢—šÂ¹)</Label>
 <input style={inp} type="number" value={advancePaid} onChange={e=>setAdvancePaid(parseFloat(e.target.value)||0)} placeholder="0" />
 {advancePaid>0 && (
 <div style={{ marginTop:8, fontSize:13, color:C.amber }}>Balance due: {inr(total-advancePaid)}</div>
 )}
 </div>

 <div style={{ marginTop:14 }}>
 <Label>Internal Notes</Label>
 <textarea value={notes} onChange={e=>setNotes(e.target.value)} placeholder="Any special requirements or notes..."
 style={{...inp, height:70, resize:'vertical'}} />
 </div>
 </div>
 )}
 </div>

 {/* Footer */}
 <div style={{ padding:'14px 20px', borderTop:`1px solid ${C.border}`, display:'flex', justifyContent:'space-between', flexShrink:0, background:C.surface }}>
 <button onClick={()=>step>1?setStep(s=>s-1):onClose()}
 style={{ padding:'10px 20px', background:'none', border:`1px solid ${C.border2}`, borderRadius:8, color:C.text2, cursor:'pointer', fontSize:13 }}>
 {step===1?'Cancel':'Ã¢— Â Back'}
 </button>
 <div style={{ display:'flex', gap:10, alignItems:'center' }}>
 {step===4 && <div style={{ fontSize:14, fontWeight:800, color:C.accent }}>{inr(total)}</div>}
 {step<4
 ? <button onClick={()=>setStep(s=>s+1)} style={{ padding:'10px 24px', background:C.accent, border:'none', borderRadius:8, color:'#fff', cursor:'pointer', fontSize:13, fontWeight:700 }}>Next Ã¢— ’</button>
 : <button onClick={handleSave} disabled={saving} style={{ padding:'10px 24px', background:C.accent, border:'none', borderRadius:8, color:'#fff', cursor:'pointer', fontSize:14, fontWeight:700, opacity:saving?.6:1 }}>
 {saving?'Saving…':bookingToEdit?'Update Booking':'Ã¢Å‘‘ Confirm Booking'}
 </button>
 }
 </div>
 </div>
 </div>
 </div>
 );
}
